export const guidelines_manuals = [
  {
    id: 1,
    name: 'PAIA manual 2024-25',
    summary: 'shortsummary/PAIA_manual_2024-25.html',
    link: 'PAIA_Manual.pdf',
    audio_en: 'audio/en/PAIA_Manual_en.mp3',
    audio_af: 'audio/af/PAIA_Manual_af.mp3',
    audio_xh: 'audio/xh/PAIA_Manual_xh.mp3'
  },
  {
    id: 2,
    name: 'RENTAL HOUSING TRIBUNAL2',
    summary: 'shortsummary/RENTAL_HOUSING_TRIBUNAL2.html',
    link: 'RENTAL HOUSING TRIBUNAL.pdf',
    audio_en: 'audio/en/RENTAL HOUSING TRIBUNAL_en.mp3',
    audio_af: 'audio/af/RENTAL HOUSING TRIBUNAL_af.mp3',
    audio_xh: 'audio/xh/RENTAL HOUSING TRIBUNAL_xh.mp3'
  }
];